import { Controller } from '@hotwired/stimulus'

/*
The first and quite possibly only use-case for this controller is to make an entire 
table row act like a link, which is otherwise difficult because an <a> tag gets
rejected when it wraps a <tr> element.
This allows clicking anywhere within an element to trigger a click() call on
the first link found within that element.
*/
export default class extends Controller {
  static targets = ['subject']

  connect() {
    this.subjectTargets.forEach((subject) => {
      subject.addEventListener('click', (e) => {
        // if the user clicked directly on a link, we are not needed
        if (e.target instanceof HTMLAnchorElement) return

        // if the user is trying to select text, we are not wanted
        if (window.getSelection().toString()) return

        // let elements opt out (e.g. a "+N" preview popover trigger/panel) so their own
        // click behavior isn't hijacked into navigating away
        if (e.target.closest('[data-linkify-ignore]')) return

        // click() the first anchor element we find within the subject
        const firstAnchor = subject.querySelector('a')
        if (firstAnchor) {
          e.preventDefault()
          firstAnchor.click()
        }
      })
    })
  }
}
